<template>
    <div style="border: 0px solid red" class="mt-4">
        <v-simple-table dense fixed-header>
            <thead>
                <tr>
                    <th class="text-center">Ordem</th>
                    <th>Árvore</th>
                    <th>Autor</th>
                    <th>Lançada</th>
                    <th>Modificada</th>
                </tr>
            </thead>
            <tbody>
                <arvore-item
                    v-for="(arvore, idx) in arvores"
                    :key="arvore.id"
                    :arvore="arvore"
                    :primeira="arvore.ordem <= 1"
                    :ultima="idx === arvores.length - 1"
                    @orderDown="orderDown"
                    @orderUp="orderUp"
                />
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import ArvoreItem from "./ArvoreItem.vue";

export default {
    name: "ListaArvores",
    props: {
        arvores: { required: true },
    },
    components: { ArvoreItem },
    methods: {
        orderDown(id) {
            this.$emit("orderDown", id);
        },
        orderUp(id) {
            this.$emit("orderUp", id);
        },
    },
};
</script>
